import { defineComponent as _defineComponent } from 'vue'
import TermsHeader from "@/components/landing/TermsHeader.vue";
  import LandingFooter from "@/components/landing/LandingFooter.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props, { expose: __expose }) {
  __expose();

  
const __returned__ = { TermsHeader, LandingFooter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})